<!---------sidebar-->
<!-- <app-alerts *ngIf="showAlerts"></app-alerts> -->
<app-alerts  ></app-alerts>
<div class="container inq-mt-st ">
  <section class="row">
    <div class="col-md-3">
      <div class="container">
        <div *ngIf="config.title != 'Haven'  && active && active!==null && active!==undefined && active!==' '">
          <a   (click)="clearAll()" class="desktop-only"  style="cursor: pointer;
          font-size: 18px;
          color: #dc3545!important;position: relative;top: 32px;left: -65px;">Clear</a></div>
      </div>


      <div class="inq-menu-left-st" *ngIf="config.title !== 'Haven'">
         
        <!-----------tams------>
        <div *ngIf="config.title != 'Haven'">
         
         
          <ul
            *ngFor="let category of allCategories; let i = index"
            [class.active]="selectedIndex === i"
            (click)="setIndex(i)"
          >
            <li 
              *ngIf="config.title != 'Mayan'"
              [class.active]="
                active === category.name || categoryName === category.name
              "
              class="active"
              (click)="getProductByFilter(category)"
            >
              {{ category.name }}
            </li>
            
            <div class="desktop-only"  *ngIf="config.title == 'Mayan'">
             
            <li id= category.name
              *ngIf="config.title == 'Mayan'"
              [class.active]="
                categoryNameFromHome != undefined
                  ? categoryNameFromHome === category.name ||
                    categoryName === category.name
                  : active === category.name
              "
              (click)="getProductByFilter(category)"
            >
              {{ category.name }}
            </li>
          </div>
          <!-- filter -->
          <!-- <div   class="mobile-only" *ngIf="config.title == 'Mayan'">
            <app-product-filter 
            [filters]="facets"  
           [categoriesList]="category" [configTitle]="config.title">

          </app-product-filter>
         
          </div> -->

          <div *ngIf="config.title === 'Mayan'">
    
            <div *ngIf="allCategories.length>0" class="layerd-navigation">
                
                <div class="filter-collections-group mobile-filter">
                    <div id="accordion">
                        <div id="accordion">
                            <h5 class="mb-0">
                                <a id="mob-filter"  data-toggle="collapse" data-target="#collapseOne" aria-expanded="false"
                                    aria-controls="collapseOne" style="float:right;position:absolute;top:90%;left:70%;text-transform: none;cursor: pointer;color:#3c707c !important; font-size: 21px;font-weight: 600px;margin-top:10px; z-index: 100;">
                                    Filter <i    aria-hidden="true" class="fa fa-filter filter-icon"></i> </a>
                            </h5>
                        </div>
                    </div>
                    <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordion" style="transition: all 0.5s ease-out;">
                       
                        <div class="card-body mob-categories">
                          <a  data-toggle="collapse" data-target="#collapseOne"  style="cursor: pointer;font-size: 14px;color: #dc3545!important;position: relative;text-decoration: underline;" (click)="clearAll()">Clear all</a>
                            <div data-toggle="collapse" data-target="#collapseOne" aria-expanded="false"
                            aria-controls="collapseOne" style="font-family: 'proxima-regular','sans-serif'!important; font-weight: 1000; float:right"> <i class="fa fa-angle-left pl-2" (click)="clearAll()"></i> &nbsp;Back</div>
                            <ng-container>
                                <div class="sublist-font" *ngFor="let category of allCategories; index as i"
                                    style="margin-bottom: 6px; line-height:1.3rem">
                                    <hr style="margin:0.7rem; background-color:white !important;border:none !important">
                                    <div class="wrapper">
                                        <li><a [class.active]="active === category.name || categoryName===category.name"
                                                class="sub-list-mob-aiema" style="font-family: 'proxima-regular','sans-serif'!important;color:#3c707c!important;font-size: 16px; font-weight:100"
                                                (click)="getProductByFilter(category)"  data-target="#collapseOne" aria-expanded="false"
                                                aria-controls="collapseOne">{{category.name | titlecase |
                                                productDetailsPipe: category.name}}<span *ngIf="category.subcategories">  </span></a></li>
                                    </div>
                                </div>
                            </ng-container>
                            <div  class="layerd-navigation">
                              <div class="filter-collections-group">
                                  <div id="accordion">
                                      <a class="sub-heading" data-toggle="collapse" data-target="#collapseEleven" aria-expanded="true"
                                          aria-controls="collapseEleven" style="cursor: pointer;color:#3c707c!important;position: relative;
                                          left: 16px;">Material<i
                                          class="fa fa-angle-down arrow-size"></i> </a>
                                         
                                  </div>
                                  <div id="collapseEleven" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                                      <div class="card-body">
                                          <ng-container *ngFor="let facet of material">
                      
                                              <div class="collection-collapse-block"  *ngIf="facet">
                      
                                                  <div class="pannel-title">
                      
                      
                      
                                                      <label class="checkbox-container"
                                                          style="text-transform: uppercase; font-size:12px !important; ">
                      
                                                          <input type="checkbox" [id]='facet.name' (click)="appliedFilterMaterial($event,facet)"  [checked]="isChecked(facet.name)"   (change)="toggleCheckbox(facet.name)" />
                                                          <!-- <input type="checkbox"  (click)="appliedFilterColor($event,facet)"/> -->
                      
                                                          &nbsp;{{ facet.name }} <span class="count"></span>
                                                          <span class="checkmark"></span>
                                                      </label>
                      
                      
                                                  </div>
                      
                                              </div>
                                          </ng-container>
                                      </div>
                                  </div>


                                  <button id="collapseFilter" class="mobile-only filter-button" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                                  aria-controls="collapseFilter">Apply Filter</button>
                                  
                              </div>
                      
                          </div>
                          <div class="layerd-navigation" style="margin-top: 10px;">
                            <div class="filter-collections-group">
                              <div id="accordion">
                                <a class="sub-heading" data-toggle="collapse" data-target="#collapsefifty" aria-expanded="true"
                                aria-controls="collapsefifty" style="cursor: pointer;color:#3c707c!important;position: relative;
                                left: 16px;">Weight<i
                                class="fa fa-angle-down arrow-size"></i> </a>
                              </div>
                              <div id="collapsefifty" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                                <div class="card-body">
                                  <ng-container *ngFor="let wgt of weight;let i = index;">
                                    <div class="collection-collapse-block"  *ngIf="wgt">
                                      <div class="pannel-title">
                                        <label class="checkbox-container"
                                        style="font-size:14px !important;font-family: proxima-regular,sans-serif;">
                        
                        
                                        <input type="checkbox" [id]='wgt.name' (click)="appliedFilterWeight($event,wgt)"  [checked]="isweightChecked(wgt.name)"   (change)="toggleweightCheckbox(wgt.name)" />
                                                         
                        
                                                          &nbsp;{{ wgt.name }}kg <span class="count"></span>
                                                          <span class="checkmark"></span>
                                      </label>
                        
                        
                                      </div>
                        
                        
                                    </div>
                        
                        
                        
                        
                                  </ng-container>
                        
                                </div>
                              </div>
                        
                        
                        
                        
                        
                           </div>
                            </div>
                            
                            <div class="touch-out" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false"
                            aria-controls="collapseOne" >
                                
                            </div>
                        </div>

                       

                    </div>            
                </div>


            </div>
           
      


       
            <div class="pb-6"></div>
            </div>
            








         <!-- filter -->






          
            <div *ngIf="categoryName === category.name">
              <ul *ngFor="let subCategory of subCategory2; let i = index">
                <li
                  [class.active]="active === subCategory.name"
                  (click)="getProductByFilter1(subCategory.name)"
                >
                  {{ subCategory.name }}
                </li>
              </ul>
            </div>
          </ul>
        </div>
        <div *ngIf="config.title === 'Mayan'" style="text-align: right!important;" class="desktop-only" >
          <div *ngIf="material" >
            <div *ngIf="material.length != 0" class="layerd-navigation">
              <div class="filter-collections-group">
                <div id="accordion">
                  <a id="material_mayan" class="sub-heading" data-toggle="collapse" data-target="#collapseEleven" aria-expanded="true"
                  aria-controls="collapseEleven" style="cursor: pointer;color:#3c707c!important;font-weight: 700;font-size: 20px!important;">Material<i
                  class="fa fa-angle-down arrow-size"></i> </a>
                </div>
                <div id="collapseEleven" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                  <div class="card-body">
                    <ng-container *ngFor="let facet of material;let i = index;">
                      <div class="collection-collapse-block"  *ngIf="facet">
                        <div class="pannel-title">
        
        
                          <label class="checkbox-container"
                                            style="font-size:14px !important;font-family: proxima-regular,sans-serif;">
        
                                            <input type="checkbox" [id]='facet.name' (click)="appliedFilterMaterial($event,facet)"  [checked]="isChecked(facet.name)"   (change)="toggleCheckbox(facet.name)" />
                                           
        
                                            &nbsp;{{ facet.name }} <span class="count"></span>
                                            <span class="checkmark"></span>
                                        </label>
        
                        </div>
        
                      </div>
        
                       
                      
        
                    </ng-container>
        
        
                  </div>
                </div>
        
        
        
        
        
             </div>
              </div>
            </div> 
<!-- weightfilter -->
<div *ngIf="weight">
  <div *ngIf="weight.length != 0" class="layerd-navigation" style="margin-top: 10px;">
    <div class="filter-collections-group">
      <div id="accordion">
        <a class="sub-heading" data-toggle="collapse" data-target="#collapsefifty" aria-expanded="true"
        aria-controls="collapsefifty" style="cursor: pointer;color:#3c707c!important;font-size: 20px!important" id="weigth_mayan">Weight<i
        class="fa fa-angle-down arrow-size"></i> </a>
      </div>
      <div id="collapsefifty" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
        <div class="card-body">
          <ng-container *ngFor="let wgt of weight;let i = index;">
            <div class="collection-collapse-block"  *ngIf="wgt">
              <div class="pannel-title">
                <label class="checkbox-container"
                style="font-size:14px !important;font-family: proxima-regular,sans-serif;">


                <input type="checkbox" [id]='wgt.name' (click)="appliedFilterWeight($event,wgt)"  [checked]="isweightChecked(wgt.name)"   (change)="toggleweightCheckbox(wgt.name)" />
                                 

                                  &nbsp;{{ wgt.name }}kg <span class="count"></span>
                                  <span class="checkmark"></span>
              </label>


              </div>


            </div>




          </ng-container>

        </div>
      </div>





   </div>
    </div>
  </div> 



<!-- end -->


        </div>


      </div>
      <div class="inq-menu-left1-st" *ngIf="config.title === 'Haven'">
        <!----------haven---->
        <div *ngIf="config.title == 'Haven'">
          <ul
            *ngFor="let category of allCategories; let i = index"
            [class.active]="selectedIndex === i"
            (click)="setIndex(i)"
          >
            <li
              [class.active]="
                active === category.name || categoryName === category.name
              "
              class="active"
              (click)="getProductByFilter(category)"
            >
              <img
                [src]="
                  category.category_icon
                    ? category.category_icon
                    : 'https://d18xkwaipu1whh.cloudfront.net/CommonAsset/canape.jpg'
                "
                class="mb-2"
                width="18"
                height="21"
              />
              {{ category.name }}
            </li>
            <div *ngIf="categoryName === category.name">
              <ul *ngFor="let subCategory of subCategory2; let i = index">
                <li
                  style="margin-left: 65px !important"
                  [class.active]="active === subCategory.name"
                  (click)="getProductByFilter1(subCategory.name)"
                >
                  {{ subCategory.name }}
                </li>
              </ul>
            </div>
          </ul>
        </div>
        <!------>
      </div>
     
    </div>
    <div class="col-md-9">
      <div class="inq-menu-right-st">
        <!----------breadcrumb----->
        <h2></h2>
        <!------------tams----->
        <div class="inq-title-st" *ngIf="config.title != 'Haven'">
          <h3
            *ngIf="config.title != 'Mayan' && subCategory !== undefined"
            class="mb-4"
          >
            {{ category1 }}
          </h3>
          <h3
            *ngIf="config.title != 'Mayan' && subCategory === undefined"
            class="mb-4"
          >
            {{ category }}
          </h3>
          
          <h3
            *ngIf="config.title == 'Mayan' && subCategory !== undefined"
            class="mb-4"
            style="color: #3c707c;font-size: 19px;"
          >
          {{ category1 }} -{{ totalProductLength }} Items
          </h3>
          <h3
            *ngIf="config.title == 'Mayan' && subCategory === undefined"
            class="mb-4"
            style="color: #3c707c;font-size: 19px;margin-left: 15px;" 
          >
         {{ category }} - {{ totalProductLength }} Items
          </h3>
          <h4 *ngIf="subCategory !== undefined">{{ subCategory }}</h4>
          <p  *ngIf="config.title !== 'Mayan'">{{ totalProductLength }} ITEMS</p>
        </div> 
        <!-----------haven----->
        <div class="inq-title-st" *ngIf="config.title == 'Haven'">
          <h3 *ngIf="subCategory !== undefined" class="mb-4">
            {{ category1 }}
            <img
              [src]="
                categoryIcon
                  ? categoryIcon
                  : 'https://d18xkwaipu1whh.cloudfront.net/CommonAsset/starter.jpg'
              "
              class="pb-2"
              height="50"
              width="50"
            />
          </h3>
          <h3 *ngIf="subCategory === undefined" class="mb-4">
            {{ category }}
            <img
              [src]="
                categoryIcon
                  ? categoryIcon
                  : 'https://d18xkwaipu1whh.cloudfront.net/CommonAsset/starter.jpg'
              "
              class="pb-2"
              height="50"
              width="50"
            />
          </h3>
          <h4 *ngIf="subCategory !== undefined">{{ subCategory }}</h4>
          <p>{{ totalProducts }} ITEMS</p>
        </div>
        <!-- ---------Prodict TAMS listing-->

        <div
          *ngIf="
            (totalLength > 0 && config.title === 'Tams') ||
            config.title === 'Mayan' ||
            config.title === 'BBold'
          "
          class="thumb"
        >
          <div *ngFor="let product of productList | paginate: {id: 'pagination-controls', itemsPerPage: countPerPage, currentPage: currentPageInPagination,totalItems: totalLength};let i = index">
            <div class="row inq-pro-sec-st listProduct">
              <div
                [class]="
                  config.title == 'Tams'
                    ? 'tams-product-list-cards'
                    : 'mayan-product-list-cards'
                "
               
              >
                <div>
                  <!------------tams img------>
                  <img *ngIf=" config.title !== 'Mayan'"
                    [src]="product.assets[0].image_source"
                    id="img-list"
                    (click)="productDetails(product.id)"
                    onerror="this.onerror=null;this.src='assets/images/tams/NoImage.png';"
                    alt="{{ product.name }}"
                    class="product-list-image"
                  />
                  <div class="card-img-top mob_lst_image"><img *ngIf=" config.title == 'Mayan'"
                    [src]="product.assets[0].image_source"
                    id="img-list "
                    (click)="productDetails(product.id,product.categories[0].path,product.name+'-'+product.id)"
                    onerror="this.onerror=null;this.src='assets/images/mayan/no img.png';"
                    alt="{{ product.name }}"
                    class="product-list-image mayan_img_center"
                  /></div>
                  
                </div>
                <div class="product-list-description description">
                  <div  *ngIf="config.title == 'Mayan'" class="justify-content-between">
                    <p
                    *ngIf="config.title == 'Mayan'" (click)="productDetails(product.id,product.categories[0].path,product.name+'-'+product.id)"
                    class="product-list-tile-mayan  desktop-only" style="text-align: center"
                  >
                    {{
                      metaDataMapService.findData(
                        product,
                        fields[1].nestedinfo
                      )
                    }}
                  </p>
                  <p
                  *ngIf="config.title == 'Mayan'" (click)="productDetails(product.id,product.categories[0].path,product.name+'-'+product.id)"
                  class="product-list-tile-mayan mobile-only" style="text-align: left"
                >
                  {{
                    metaDataMapService.findData(
                      product,
                      fields[1].nestedinfo
                    )
                  }}
                </p>

                  </div>

                  <div class="d-flex justify-content-between">
                    <div>
                      <p
                        *ngIf="config.title != 'Mayan'"
                        (click)="productDetails(product.id)"
                        class="product-list-tile"
                      >
                        {{
                          metaDataMapService.findData(
                            product,
                            fields[1].nestedinfo
                          )
                        }}
                      </p>
                     
                    </div>
                    <div *ngIf="config.title!=='Mayan'">
                      <p
                        [class]="
                          config.title == 'Tams'
                            ? 'product-list-price'
                            : 'mayan-product-list-price'
                        "
                        *ngIf="!product.showPricse"
                      >
                        ₹{{
                          product.variant.option_values[0].pricing.raw.price
                        }}.00
                      </p>
                      <p
                        [class]="
                          config.title == 'Tams'
                            ? 'product-list-price'
                            : 'mayan-product-list-price'
                        "
                        *ngIf="
                          product.showPricse &&
                          product.product_type == 'Variable'
                        "
                      >
                        ₹{{ product.pricee }}.00
                      </p>
                      <p
                        [class]="
                          config.title == 'Tams'
                            ? 'product-list-price'
                            : 'mayan-product-list-price'
                        "
                        *ngIf="
                          product.showPricse &&
                          (product.product_type == 'Simple' ||
                            product.product_type == 'Variation')
                        "
                      >
                        ₹{{ product.pricing.raw.price }}.00
                      </p>
                      <!-- <p class="product-list-price"  *ngIf="product.product_type=='Simple' ||product.product_type =='Variation' "style="font-size: 11px !important; font-weight: 500 !important;color: rgb(78, 77, 77) !important;padding-left:8px !important">₹{{product.pricing.raw.price + '.00'}}</p>  -->
                      <p
                        [class]="
                          config.title == 'Tams'
                            ? 'product-list-price'
                            : 'mayan-product-list-price'
                        "
                        *ngIf="product.product_type == 'Variable'"
                        style="
                          font-size: 11px !important;
                          font-weight: 500 !important;
                          color: rgb(78, 77, 77) !important;
                          padding-left: 8px !important;
                        "
                      >
                        ₹{{ product.pricing.raw.price_range_from }}-{{
                          product.pricing.raw.price_range_to
                        }}
                      </p>
                    </div>
                    
                    <!-- <div *ngIf="config.title=='Mayan'">
                      <p
                        [class]="'mayan-product-list-price'
                        "
                        *ngIf="!product.pricing.raw.price "
                      >
                      Unavailable
                      </p>
                      <p
                        [class]="'mayan-product-list-price'
                        "
                        *ngIf="product.pricing.raw.price"
                      >
                        ₹{{
                          product.pricing.raw.price
                        }}.00
                      </p> -->
                      <!-- <p
                        [class]="
                         
                            'mayan-product-list-price'
                        "
                        *ngIf="
                          product.showPricse &&
                          product.product_type == 'Variable'
                        "
                      >
                        ₹{{ product.pricee }}.00
                      </p>
                      <p
                        [class]="
                          
                             'mayan-product-list-price'
                        "
                        *ngIf="
                          product.showPricse &&
                          (product.product_type == 'Simple' ||
                            product.product_type == 'Variation')
                        "
                      >
                        ₹{{ product.pricing.raw.price }}.00
                      </p> -->
                      <!-- <p class="product-list-price"  *ngIf="product.product_type=='Simple' ||product.product_type =='Variation' "style="font-size: 11px !important; font-weight: 500 !important;color: rgb(78, 77, 77) !important;padding-left:8px !important">₹{{product.pricing.raw.price + '.00'}}</p>  -->
                      <!-- <p
                        [class]="
                          
                           
                             'mayan-product-list-price'
                        "
                        *ngIf="product.product_type == 'Variable'"
                        style="
                          font-size: 11px !important;
                          font-weight: 500 !important;
                          color: rgb(78, 77, 77) !important;
                          padding-left: 8px !important;
                        "
                      >
                        ₹{{ product.pricing.raw.price_range_from }}-{{
                          product.pricing.raw.price_range_to
                        }}
                      </p> -->
                    <!-- </div> -->
                    <!-- <div class="inner-star-icon pd-1" *ngIf="config.title=='Mayan'">
                      <span 
                        [class]="
                          product &&
                          product.reviews &&
                          product.reviews.average >= 1
                            ? 'fa fa-star checked'  
                            : 'fa fa-star unchecked'
                        "
                      ></span>
                      <span  
                        [class]="
                          product &&
                          product.reviews &&
                          product.reviews.average >= 2
                            ? 'fa fa-star checked'
                            : 'fa fa-star unchecked'
                        "
                      ></span>
                      <span
                        [class]="
                          product &&
                          product.reviews &&
                          product.reviews.average >= 3
                            ? 'fa fa-star checked'
                            : 'fa fa-star unchecked'
                        "
                      ></span>
                      <span  
                        [class]="
                          product &&
                          product.reviews &&
                          product.reviews.average >= 4
                            ? 'fa fa-star checked'
                            : 'fa fa-star unchecked'
                        "
                      ></span>
                      <span  
                        [class]="
                          product &&
                          product.reviews &&
                          product.reviews.average >= 5
                            ? 'fa fa-star checked'
                            : 'fa fa-star unchecked'
                        "
                      ></span>


</div> -->

                  </div>
                  <div *ngIf="config.title === 'Tams' && product.shipping && product.name.includes('Flour')">
                    <small style="color: #ff6e40">
                      {{
                        product.shipping.weight === 5000
                          ? "Yields 12.5kg batter"
                          : "Yields 2.5kg batter"
                      }}
                    </small>
                  </div>
                  <!----------variants------>
                  <app-shared-variants  *ngIf="config.title !='Mayan'"
                    [product]="product"
                    [products]="products"
                    (selectEmitter)="showPrice($event)"
                  ></app-shared-variants>

                  <!-- <div>

                <label class='note'  style="font-size: 11px !important; font-weight: 500 !important;color: black !important;">Note: Please select option to add item in
                    cart</label>

            </div> -->

                  <!---------------------reviews---------------->
                  <div  *ngIf="config.title !='Mayan'"
                    class="d-flex justify-content-between mt-1 mob_bt_prc"
                    style="padding-top: -15px"
                  >
                  <!-- <div *ngIf="config.title=='Mayan'">
                    <p
                      [class]="'mayan-product-list-price'
                      "
                      *ngIf="!product.pricing.raw.price "
                    >
                    Out of Stock
                    </p>
                    <p
                      [class]="'mayan-product-list-price mayan_feature'
                      "
                      *ngIf="product.pricing.raw.price"
                    >
                      ₹{{
                        product.pricing.raw.price
                      }}.00
                    </p> -->
                    <!--  bottom already cmd -->
                    <!-- <p
                      [class]="
                       
                          'mayan-product-list-price'
                      "
                      *ngIf="
                        product.showPricse &&
                        product.product_type == 'Variable'
                      "
                    >
                      ₹{{ product.pricee }}.00
                    </p>
                    <p
                      [class]="
                        
                           'mayan-product-list-price'
                      "
                      *ngIf="
                        product.showPricse &&
                        (product.product_type == 'Simple' ||
                          product.product_type == 'Variation')
                      "
                    >
                      ₹{{ product.pricing.raw.price }}.00
                    </p> -->
                    <!-- <p class="product-list-price"  *ngIf="product.product_type=='Simple' ||product.product_type =='Variation' "style="font-size: 11px !important; font-weight: 500 !important;color: rgb(78, 77, 77) !important;padding-left:8px !important">₹{{product.pricing.raw.price + '.00'}}</p>  -->
                    <!-- <p
                      [class]="
                        
                         
                           'mayan-product-list-price'
                      "
                      *ngIf="product.product_type == 'Variable'"
                      style="
                        font-size: 11px !important;
                        font-weight: 500 !important;
                        color: rgb(78, 77, 77) !important;
                        padding-left: 8px !important;
                      "
                    >
                      ₹{{ product.pricing.raw.price_range_from }}-{{
                        product.pricing.raw.price_range_to
                      }}
                    </p> -->
                  
                    <div class="inner-star-icon pd-1">
                      <span 
                        [class]="
                          product &&
                          product.reviews &&
                          product.reviews.average >= 1
                            ? 'fa fa-star checked'
                            : 'fa fa-star unchecked'
                        "
                      ></span>
                      <span 
                        [class]="
                          product &&
                          product.reviews &&
                          product.reviews.average >= 2
                            ? 'fa fa-star checked'
                            : 'fa fa-star unchecked'
                        "
                      ></span>
                      <span 
                        [class]="
                          product &&
                          product.reviews &&
                          product.reviews.average >= 3
                            ? 'fa fa-star checked'
                            : 'fa fa-star unchecked'
                        "
                      ></span>
                      <span  
                        [class]="
                          product &&
                          product.reviews &&
                          product.reviews.average >= 4
                            ? 'fa fa-star checked'
                            : 'fa fa-star unchecked'
                        "
                      ></span>
                      <span 
                        [class]="
                          product &&
                          product.reviews &&
                          product.reviews.average >= 5
                            ? 'fa fa-star checked'
                            : 'fa fa-star unchecked'
                        "
                      ></span>
                      <a
                        *ngIf="config.title == 'Tams'"
                        routerLink="/product-review/{{ product.id }}"
                        style="
                          color: #000000 !important;
                          font-size: 11px !important;
                          font-weight: 500 !important;
                        "
                      >
                        {{
                          product && product.reviews
                            ? product.reviews.total_reviews
                            : 0
                        }}
                        reviews</a
                      >
                      <!-- <a
                        *ngIf="config.title !== 'Mayan'"
                        routerLink="/product-review/{{ product.id }}"
                        style="
                          color: #000000 !important;
                          font-size: 11px !important;
                          font-weight: 500 !important;
                        "
                      >
                        {{
                          product && product.reviews
                            ? product.reviews.total_reviews
                            : 0
                        }}
                        reviews</a
                      > -->
                      <a
                        *ngIf="config.title == 'BBold'"
                        routerLink="/product-review/{{ product.id }}"
                        style="
                          color: #ffffff !important;
                          font-size: 11px !important;
                          font-weight: 500 !important;
                        "
                      >
                        {{
                          product && product.reviews
                            ? product.reviews.total_reviews
                            : 0
                        }}
                        reviews</a
                      >
                    </div>
                    <div>
                      <!-- <a class="product-list-cart">ADD TO CART +</a> -->
                      <!--------- button---------->

                      <!-------------Add to cart-->
                      <button
                        class="cartButton"
                        style="
                          font-size: small;
                          font-weight: bold;
                          width: 80px;
                          background-color: transparent !important;
                          border: 1px solid #3c707c !important;
                          color: #3c707c !important;
                          margin-left:0% !important;
                          background-color: grey;
                        "
                        (click)="addToCarts(product)"
                        *ngIf="
                          config.title === 'Tams' &&
                          ((product.product_type != 'Variable' &&
                            appService.productIdinCart.indexOf(product.id) ==
                              -1) ||
                            (product.product_type == 'Variable' &&
                              appService.productIdinCart.indexOf(
                                product.checkVariantInCart
                              ) == -1) ||
                            (product.product_type == 'Simple' &&
                              appService.productIdinCart.indexOf(product.id) ==
                                -1) ||
                            (product.product_type == 'Variation' &&
                              appService.productIdinCart.indexOf(product.id) ==
                                -1))
                        "
                      >
                        ADD <span> <i class="fa fa-shopping-cart"></i></span>
                      </button>
                      <button
                        class="cartButton"
                        style="
                          font-size: small;
                          font-weight: bold;
                          width: 80px;
                          background-color: transparent !important;
                          border: 1px solid #3c707c !important;
                          color: #3c707c !important;
                          background-color: grey;
                        "
                        (click)="addToCarts(product)"
                        *ngIf="
                          config.title === 'BBold' &&
                          ((product.product_type != 'Variable' &&
                            appService.productIdinCart.indexOf(product.id) ==
                              -1) ||
                            (product.product_type == 'Variable' &&
                              appService.productIdinCart.indexOf(
                                product.checkVariantInCart
                              ) == -1) ||
                            (product.product_type == 'Simple' &&
                              appService.productIdinCart.indexOf(product.id) ==
                                -1) ||
                            (product.product_type == 'Variation' &&
                              appService.productIdinCart.indexOf(product.id) ==
                                -1))
                        "
                      >
                        ADD <span> <i class="fa fa-shopping-cart"></i></span>
                      </button>
                      <!-- <div style="width: 100%;">
                      <button 
                        class="mayancartButton mayanli-but" style="border: 3px solid #3c707c !important;"
                      
                        (click)="addToCarts(product)"
                        *ngIf="
                          config.title === 'Mayan' &&
                          ((product.product_type != 'Variable' &&
                            appService.productIdinCart.indexOf(product.id) ==
                              -1) ||
                            (product.product_type == 'Variable' &&
                              appService.productIdinCart.indexOf(
                                product.checkVariantInCart
                              ) == -1) ||
                            (product.product_type == 'Simple' &&
                              appService.productIdinCart.indexOf(product.id) ==
                                -1) ||
                            (product.product_type == 'Variation' &&
                              appService.productIdinCart.indexOf(product.id) ==
                                -1)) && product.pricing.raw.price
                        "
                      >
                        ADD <span> <i class="fa fa-shopping-cart"></i></span>
                      </button>
                    </div> -->
                      <!---------view cart button-->
                      <div
                        *ngIf="
                          appService.productIdinCart.indexOf(product.id) !=
                            -1 ||
                          appService.productIdinCart.indexOf(
                            product.checkVariantInCart
                          ) != -1
                        "
                      >
                        <div
                          *ngFor="
                            let cart of appService.cartProducts.results;
                            let i = index
                          "
                        >
                          <div
                            [class]="
                              config.title == 'Tams'
                                ? 'viewCart'
                                : 'mayanviewCart mob_view quantity-box'
                            "
                            style="
                              font-size: small;
                              font-weight: bold;
                              padding-left: 4px;
                              padding-right: 4px;
                            "
                            *ngIf="
                              cart.product_id === product.id ||
                              cart.product_id === product.checkVariantInCart
                            "
                          >
                            <span>
                              <i
                                class="fa fa-minus mr-3"
                                (click)="decreaseItem(i)"
                                style="font-size: 12px; cursor: pointer"
                              ></i
                            ></span>
                            <span class="inq-sp-2" style="color: white">{{
                              cart.quantity
                            }}</span>
                            <span>
                              <i
                                class="fa fa-plus ml-3"
                                (click)="increaseItem(i)"
                                style="font-size: 12px; cursor: pointer"
                              ></i
                            ></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>





<!-- mayan reference -->
<div  *ngIf="config.title =='Mayan'"
class="mayan-addlist"
style="padding-top: -15px"
>
<div *ngIf="config.title=='Mayan'">
  <p
    [class]="'mayan-product-list-priceout'
    "
    *ngIf="!product.pricing.raw.price "
  >
  Out of Stock
  </p>
  <p
    [class]="'mayan-product-list-price mayan_feature'
    "
    *ngIf="product.pricing.raw.price"
  >
    ₹{{
      product.pricing.raw.price
    }}.00
  </p>

</div>

<div style="width: 100%;">
  <button 
    class="mayancartButton mayanli-but" style="border: 3px solid #3c707c !important;font-weight: bold;font-size: 14px;width: 75px;"
  
    (click)="addToCarts(product)"
    *ngIf="
      config.title === 'Mayan' &&
      ((product.product_type != 'Variable' &&
        appService.productIdinCart.indexOf(product.id) ==
          -1) ||
        (product.product_type == 'Variable' &&
          appService.productIdinCart.indexOf(
            product.checkVariantInCart
          ) == -1) ||
        (product.product_type == 'Simple' &&
          appService.productIdinCart.indexOf(product.id) ==
            -1) ||
        (product.product_type == 'Variation' &&
          appService.productIdinCart.indexOf(product.id) ==
            -1)) && product.pricing.raw.price
    "
  >
    ADD <span> <i class="fa fa-shopping-cart"></i></span>
  </button>
</div>

<div
*ngIf="
  appService.productIdinCart.indexOf(product.id) !=
    -1 ||
  appService.productIdinCart.indexOf(
    product.checkVariantInCart
  ) != -1
"
>

<div
*ngFor="
  let cart of appService.cartProducts.results;
  let i = index
"
>
<div style="height: 29px;"
[class]="
  config.title == 'Mayan'
    ? 'viewCartlistmay'
    : 'mayanviewCart mob_view quantity-box'
"
*ngIf="
  cart.product_id === product.id ||
  cart.product_id === product.checkVariantInCart
"
>
<span>
  <i
    class="fa fa-minus mr-3 mar-top-may"
    (click)="decreaseItem(i)"
    style="font-size: 12px; cursor: pointer"
  ></i
></span>
<span class="inq-sp-2 mar_top_may" style="color: white">{{
  cart.quantity
}}</span>
<span>
  <i
    class="fa fa-plus ml-3 mar-top-may"
    (click)="increaseItem(i)"
    style="font-size: 12px; cursor: pointer"
  ></i
></span>
</div>
</div>


</div>



</div>



















                  <div *ngIf="config.title == 'Mayan'&& this.product['shipping']!=undefined" class="product-list-description description mayan_dimen mobile-only" >
                    <div class="d-flex justify-content-between m_top ">
                      <p *ngIf="this.product['shipping']['product_height']!=undefined && this.product['shipping']['product_height']!=0"
                         
                          class="product-list-tile-mayan" 
                        >
                          H-{{product["shipping"]['product_height']
                          }}"
                        </p>
                        <p *ngIf="this.product['shipping']['product_width']!=undefined && this.product['shipping']['product_width']!=0"
                          
                          class="product-list-tile-mayan" 
                        >
                          W-{{product["shipping"]['product_width']
                        }}"
                        </p>
                        <p *ngIf="this.product['shipping']['product_length']!=undefined && this.product['shipping']['product_length']!=0"
                          
                          class="product-list-tile-mayan" 
                        >
                         L-{{product["shipping"]['product_length']
                        }}"
                        </p>
                        <p *ngIf="this.product['shipping']['diameter']!=undefined && this.product['shipping']['diameter']!=0 "
                          
                          class="product-list-tile-mayan" 
                        >
                         D-{{product["shipping"]['diameter']
                        }}"
                        </p>
  
                    </div>
  
                  </div>
                  

                  <!-- <div class="d-flex justify-content-end mt-1">
                                        <a class="product-list-cart">ADD TO CART +</a>
                                    </div> -->
                </div>
                <div *ngIf="config.title == 'Mayan' && this.product['shipping']!=undefined " class="product-list-description_dime description mayan_dimen desktop-only" >
                  <div class="d-flex justify-content-between card_top-1 " >
                    <p *ngIf="this.product['shipping']['product_height']!=undefined && this.product['shipping']['product_height']!='' && this.product['shipping']['product_height']!=0"
                       
                        class="product-list-tile-mayan" 
                      >
                        Height-<span *ngIf="this.product['shipping']['product_height']!=undefined && this.product['shipping']['product_height']!='' && this.product['shipping']['product_height']!=0" >{{product["shipping"]['product_height']}}"</span></p>
                      <p *ngIf="this.product['shipping']['product_width']!=undefined && this.product['shipping']['product_width']!='' && this.product['shipping']['product_width']!=0"
                      width
                        class="product-list-tile-mayan" 
                      >
                        Width-<span *ngIf="this.product['shipping']['product_width']!=undefined && this.product['shipping']['product_width']!='' && this.product['shipping']['product_width']!=0" >{{product["shipping"]['product_width']}}"</span></p>
                      <p *ngIf="this.product['shipping']['product_length']!=undefined && this.product['shipping']['product_length']!='' && this.product['shipping']['product_length']!=0"
                        
                        class="product-list-tile-mayan" 
                      >
                       Length-<span *ngIf="this.product['shipping']['product_length']!=undefined" >{{product["shipping"]['product_length']}}"</span></p>


                       <p *ngIf="this.product['shipping']['diameter']!=undefined && this.product['shipping']['diameter']!=0 && this.product['shipping']['diameter']!=''"
                        
                       class="product-list-tile-mayan" 
                     >
                      Diameter- <span  *ngIf="this.product['shipping']['diameter']!=undefined && this.product['shipping']['diameter']!=0 && this.product['shipping']['diameter']!=''">{{product["shipping"]['diameter']}}"</span></p>

                  </div>

                </div>
                
              </div>
            </div>
          </div>
        </div>

        <!--------------------------------------------------------->
        <!---------------haven listing------------------->
        <div
          *ngIf="
            config.title == 'Haven' ||
            ('Dosapark' &&
              config.title !== 'BBold' &&
              config.title !== 'Tams' &&
              config.title !== 'Mayan')
          "
        >
          <div
            class="row mt-4 inq-pro-sec-st"
            *ngFor="let product of products; let i = index"
          >
            <div class="col-md-8">
              <div class="col-md-10 inq-fo-des-in-st">
                <div class="inq-dis-sec-st">
                  <div class="inq-ft-st mb-1 row">
                    <div
                      class="col-md-1"
                      id="veg-img-prt"
                      *ngIf="fields[0].visibility"
                    >
                      <!-- <img src="assets/images/veg.svg" alt="veg-items"> -->
                    </div>

                    <div class="col-md-11 inq-pro-col-le-st">
                      <!-- <h5 *ngIf="fields[1].visibility">{{product.name}}</h5> -->
                      <h5
                        *ngIf="fields[1].visibility"
                        style="cursor: pointer"
                        (click)="productDetails(product.id)"
                      >
                        {{
                          metaDataMapService.findData(
                            product,
                            fields[1].nestedinfo
                          )
                        }}
                      </h5>
                      <div class="inner-star-icon">
                        <span
                          [class]="
                            product &&
                            product.reviews &&
                            product.reviews.average >= 1
                              ? 'fa fa-star checked'
                              : 'fa fa-star unchecked'
                          "
                        ></span>
                        <span
                          [class]="
                            product &&
                            product.reviews &&
                            product.reviews.average >= 2
                              ? 'fa fa-star checked'
                              : 'fa fa-star unchecked'
                          "
                        ></span>
                        <span
                          [class]="
                            product &&
                            product.reviews &&
                            product.reviews.average >= 3
                              ? 'fa fa-star checked'
                              : 'fa fa-star unchecked'
                          "
                        ></span>
                        <span
                          [class]="
                            product &&
                            product.reviews &&
                            product.reviews.average >= 4
                              ? 'fa fa-star checked'
                              : 'fa fa-star unchecked'
                          "
                        ></span>
                        <span
                          [class]="
                            product &&
                            product.reviews &&
                            product.reviews.average >= 5
                              ? 'fa fa-star checked'
                              : 'fa fa-star unchecked'
                          "
                        ></span>
                        <a routerLink="/product-review/{{ product.id }}">
                          {{
                            product && product.reviews
                              ? product.reviews.total_reviews
                              : 0
                          }}
                          customer reviews</a
                        >
                      </div>
                      <span *ngIf="fields[3].visibility"
                        ><strong
                          ><i class="fa fa-rupee"></i
                          >{{
                            metaDataMapService.findData(
                              product,
                              fields[3].nestedinfo
                            )
                          }}</strong
                        ></span
                      >
                      <span
                        style="
                          float: right;
                          font-size: 14px;
                          color: #805245 !important;
                        "
                        *ngIf="product.stock_status == 'Available'"
                        ><i
                          class="fa fa-check-circle"
                          style="font-size: 20px; color: #04aa6d"
                        ></i
                        >In Stock</span
                      >
                      <span
                        style="
                          float: right;
                          font-size: 14px;
                          color: #805245 !important;
                        "
                        *ngIf="
                          product.stock_status != 'Available' &&
                          product.stock_status != ''
                        "
                        ><i
                          class="fa fa-times"
                          style="font-size: 20px; color: #ff0000"
                        ></i
                        >Out Of Stock</span
                      >
                      <p style="padding-top: 5px !important">
                        {{ product.description.description }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-2">
              <div class="inq-fo-im-st">
                <div
                  *ngIf="
                    product.assets != undefined &&
                    product.assets.length != 0 &&
                    product.assets[0].image_source
                  "
                >
                  <img
                    [src]="product.assets[0].image_source"
                    alt="..."
                    class="img-fluid product-image"
                    style="cursor: pointer"
                    (click)="productDetails(product.id)"
                  />
                </div>
                <div
                  *ngIf="
                    product.assets.length === 0 ||
                    !product.assets[0].image_source
                  "
                >
                  <img
                    src="assets/images/No_Image_old.png"
                    style="cursor: pointer"
                    (click)="productDetails(product.id)"
                    class="img-fluid product-image"
                  />
                </div>
                <div *ngIf="appService.cartProducts.results.length > 0">
                  <div *ngIf="cartData.includes(product.id)">
                    <div
                      *ngFor="
                        let cart of appService.cartProducts.results;
                        let i = index
                      "
                    >
                      <div
                        class="add-cart1"
                        *ngIf="
                          cart.product_id === product.id &&
                          product.stock_status == 'Available'
                        "
                      >
                        <div class="inq-cart-bw-st">
                          <span>
                            <i
                              class="fa fa-minus"
                              (click)="decreaseItem(i)"
                              style="font-size: 12px; cursor: pointer"
                            ></i
                          ></span>
                          <span class="inq-sp-2" style="color: white">{{
                            cart.quantity
                          }}</span>
                          <span>
                            <i
                              class="fa fa-plus"
                              (click)="increaseItem(i)"
                              style="font-size: 12px; cursor: pointer"
                            ></i
                          ></span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="inq-cart-bw-st add-cart"
                    *ngIf="
                      !cartData.includes(product.id) &&
                      product.stock_status == 'Available'
                    "
                    (click)="addToCart(product)"
                  >
                    <span class="inq-sp-1"></span>
                    <span class="inq-sp-2 inq-secondary">ADD</span>
                    <span class="inq-sp-3"></span>
                  </div>
                </div>
                <div *ngIf="appService.cartProducts.results.length === 0">
                  <div
                    class="inq-cart-bw-st add-cart"
                    (click)="addToCart(product)"
                    *ngIf="product.stock_status == 'Available'"
                  >
                    <span class="inq-sp-1"></span>
                    <span class="inq-sp-2 inq-secondary">ADD</span>
                    <span class="inq-sp-3"></span>
                  </div>
                </div>
              </div>
            </div>
            <hr class="inq-pro-hr-st" />
          </div>
        </div>
        <!-------------->
      </div>
      <!---------------------------------------->
      <div *ngIf="config.title != 'Mayan' && totalLength < 1">
        <img
          src="https://d18xkwaipu1whh.cloudfront.net/CommonAsset/noresult.jpeg"
          class="img-fluid1"
        />
        <img src="assets/images/noresult.jpeg" class="img-fluid1" />
      </div>
      <div *ngIf="config.title == 'Mayan' && totalProductLength < 1">
        <img
          src="https://d18xkwaipu1whh.cloudfront.net/CommonAsset/noresult.jpeg"
          class="img-fluid1"
        />
      </div>
    </div>
  </section>
  <pagination-controls *ngIf="totalLength > 0" class="my-pagination" (pageChange)="pageChange($event)"
    style="float: right" id="pagination-controls"></pagination-controls>
  
</div>

